<script>
    import { getContext, createEventDispatcher } from "svelte";

    const { data, xGet, x, z, zGet, zDomain, zScale, xDomain, xScale } =
        getContext("LayerCake");

    const PATH_PREFIX = process.env.PATH_PREFIX;

    export let institution;
    export let color;
    export let hideTooltip;
    export let formatTick;
    export let textString;
    export let w;
    export let axisVar;
    export let type;
    export let textStringPreceding = "";

    const dispatch = createEventDispatcher();

    export let labelWidth;
    let sliceSelectWidth = 8;
    let window_width;
    $: onMouseEvents = window_width > 700; // tied to .interact-hide-mobile;

    function handleMouseover(i) {
        // if (!onMouseEvents) return;
        return function handleMouseoverFn(e) {
            if (i) {
                hideTooltip = false;

                i.type = type;
                dispatch("message", { e, props: i });
            } else {
                hideTooltip = true;
            }
        };
    }
    let ticks = axisVar == "x" ? $xScale.ticks(1) : [0, $zDomain[1]];
    
    $: overRightEdge =
        (axisVar == "x" ? $xGet(institution) : $zGet(institution)) +
            labelWidth / 2 >
        w;
    $: overLeftEdge =
        (axisVar == "x" ? $xGet(institution) : $zGet(institution)) -
            labelWidth / 2 <
        0;
    $: xPosLabel = overRightEdge
        ? w - labelWidth
        : overLeftEdge
        ? 0
        : (axisVar == "x" ? $xGet(institution) : $zGet(institution)) -
          labelWidth / 2;

    function handleClick(d) {
        window.location = PATH_PREFIX + "institution/" + d.slug;
    }
</script>

<svelte:window bind:innerWidth={window_width} />

<div
    class="compare-bar"
    bind:clientWidth={w}
    on:mouseout={() => {
        hideTooltip = true;
    }}
    on:blur={() => {
        hideTooltip = true;
    }}
    on:mouseleave={() => {
        hideTooltip = true;
    }}
>
    <div class="slices">
        {#each $data as i}
            {#if onMouseEvents}
                <div
                    class="slice"
                    class:slice-hover-enabled={onMouseEvents}
                    style="left: {Math.min(
                        (axisVar == 'x' ? $xGet(i) : $zGet(i)) - 1,
                        w - 1
                    )}px;"
                    on:mouseover={handleMouseover(i)}
                    on:focus={handleMouseover(i)}
                    on:click={handleClick(i)}
                    on:keydown={handleClick(i)}
                />
            {:else}
                <div
                    class="slice"
                    style="left: {Math.min(
                        (axisVar == 'x' ? $xGet(i) : $zGet(i)) - 1,
                        w - 1
                    )}px;"
                />
            {/if}
        {/each}
    </div>
    {#if onMouseEvents}
        <div
            class="slice-select"
            style="background-color: {color}; left: {Math.max(
                Math.min(
                    (axisVar == 'x' ? $xGet(institution) : $zGet(institution)) -
                        4,
                    w - sliceSelectWidth + 1
                ),
                -1
            )}px; width:{sliceSelectWidth}px;"
            on:mouseover={handleMouseover(institution)}
            on:focus={handleMouseover(institution)}
        />
    {:else}
        <div
            class="slice-select"
            style="background-color: {color}; left: {Math.max(
                Math.min(
                    (axisVar == 'x' ? $xGet(institution) : $zGet(institution)) -
                        4,
                    w - sliceSelectWidth + 1
                ),
                -1
            )}px; width:{sliceSelectWidth}px;"
        />
    {/if}
    <div
        class="slice-select-label"
        style="left: {xPosLabel}px; width: {labelWidth}px; {overRightEdge
            ? 'text-align:right;'
            : overLeftEdge
            ? 'text-align:left;'
            : ''}"
    >
        {textStringPreceding +
            formatTick(axisVar == "x" ? $x(institution) : $z(institution)) +
            " " +
            textString}
    </div>
</div>
<div class="compare-bar-labels">
    <div class="left-bar-label">{formatTick(ticks[0])}</div>
    <div class="right-bar-label">{formatTick(ticks[1])}</div>
</div>

<style lang="scss">
    .compare-bar {
        height: 1.5rem;
        border: 1px solid var(--gray-60);
        position: relative;
        margin: 2.25rem 0 0.05rem 0;
    }
    .slice {
        height: 100%;
        position: absolute;
        cursor: pointer;
        width: 2px;
        background-color: var(--gray-40);
        mix-blend-mode: multiply;
        border: 0px var(--gray-60) solid;
        opacity: 0.3;
        transition: var(--transition);
    }

    .slice-hover-enabled:hover {
        border-color: black;
        border-width: 2px;
        opacity: 1;
    }

    .compare-bar-labels {
        font-size: var(--scale-2);
        height: var(--scale-2);
    }

    .left-bar-label {
        float: left;
    }

    .right-bar-label {
        float: right;
    }

    .slice-select {
        height: calc(100% + 8px);
        top: -4px;
        filter: drop-shadow(0px 0px 3px rgba(255, 255, 255, 0.9));
        position: absolute;
        border: 1px solid var(--gray-90);
        border-radius: 1px;
    }

    .slice-select-label {
        position: absolute;
        top: -2rem;
        font-size: var(--scale-2);
        font-weight: 600;
        line-height: 0.7rem;
        text-align: center;
        line-height: var(--line-height-2);
    }
</style>
